export class ValidationRequestCatalog {

  constructor(
    public field?: string,
    public value?: string,
    public customerId?: string,
    public catalogId?: string,
    public isActivId?: boolean

  ) {

  }
}
